import React from 'react';
import { FILTER_ITEMS, SORT_ITEMS } from './constants';
import styles from './styles.module.sass';
import { RefineDataItem } from './refine-data-item';
import { useAppDispatch, useAppSelector } from 'hooks';
import { RequestStatus, SortOrder } from 'types/enums';
import { requestsActions } from 'utils/store/slice';
import { SelectChangeEvent } from '@mui/material';
import { FilterId, FilterValue, SortId } from './enums';

export const RequestRefineItems = () => {
  const { dateSortOrder, statusSort, statusFIlter } = useAppSelector((state) => state.requests);
  const dispatch = useAppDispatch();

  const onFilterChangeHandler = ({ target }: SelectChangeEvent<string>) => {
    if (target.name === FilterId.STATUS) {
      const value = (target.value === FilterValue.OFF ? null : target.value) as RequestStatus | null;
      dispatch(requestsActions.setStatusFilter(value));
    }

    dispatch(requestsActions.getPaginatedRequests());
  };
  const onSortChangeHandler = ({ target }: SelectChangeEvent<string>) => {
    if (target.name === SortId.STATUS) {
      dispatch(requestsActions.setStatusSort(target.value as RequestStatus));
    }

    if (target.name === SortId.CREATED_AT) {
      dispatch(requestsActions.setDateSortOrder(target.value as SortOrder));
    }

    dispatch(requestsActions.getPaginatedRequests());
  };

  const getValue = (value: string): string => {
    const values = {
      [FilterId.STATUS]: statusFIlter ?? FilterValue.OFF,
      [SortId.STATUS]: statusSort,
      [SortId.CREATED_AT]: dateSortOrder,
    };

    return values[value] ?? 'no value';
  };

  return (
    <div className={styles.container}>
      {FILTER_ITEMS.map(({ id, values, title }) => (
        <RefineDataItem
          id={id}
          key={id}
          title={title}
          values={values}
          value={getValue(id)}
          onChange={onFilterChangeHandler}
        />
      ))}
      {SORT_ITEMS.map(({ id, values, title }) => (
        <RefineDataItem
          id={id}
          key={id}
          title={title}
          values={values}
          value={getValue(id)}
          onChange={onSortChangeHandler}
        />
      ))}
    </div>
  );
};
